<template>
  <div class="step-three">
    <h3>{{$t('signupflow.step-3.title')}}</h3>
    <p class="description">{{$t('signupflow.step-3.description')}}</p>
    <div class="startup-options">
      <div class="option ai-option" v-if="!selectedOption || selectedOption == 'ai'">
        <transition name="quick-fade-in">
          <button v-if="selectedOption" class="back-btn" @click="selectedOption = null">
            <img src="@/assets/svg/arrow-right-ai.svg" alt="button arrow" />
          </button>
        </transition>
        <div class="top">
          <i class="fa-light fa-bolt ai-icon"></i>
          <h4>{{$t('signupflow.step-3.ai.title')}}</h4>
        </div>
        <ul :class="{ selected: selectedOption == 'ai' }">
          <li v-for="(item, index) in aiOptionList" :key="index">
            <!-- <span class="circle"><i class="fa-light fa-circle-filled"></i></span> -->
            {{ item }}
          </li>
        </ul>
        <button v-if="!selectedOption" class="btn-startup" @click="selectOption('ai')">
          <span>{{$t('signupflow.step-3.ai.start-btn')}}</span> <img src="@/assets/svg/arrow-right-ai.svg" alt="button arrow" />
        </button>
      </div>

      <div class="option template-option" v-if="!selectedOption || selectedOption == 'template'">
        <transition name="quick-fade-in">
          <button v-if="selectedOption" class="back-btn" @click="selectedOption = null">
            <img src="@/assets/svg/arrow-right-template.svg" alt="button arrow" />
          </button>
        </transition>
        <div class="top">
          <img class="template-icon" src="@/assets/svg/template-option-icon.svg" alt="template option icon" />
          <h4>{{$t('signupflow.step-3.premium.title')}}</h4>
        </div>
        <ul :class="{ selected: selectedOption == 'template' }">
          <li v-for="(item, index) in templateOptionList" :key="index">{{ item }}</li>
        </ul>
        <button v-if="!selectedOption" class="btn-startup" @click="selectOption('template')">
          <span>{{$t('signupflow.step-3.premium.start-btn')}}</span> <img src="@/assets/svg/arrow-right-template.svg" alt="button arrow" />
        </button>
      </div>

      <div
        v-if="selectedOption"
        class="last-step"
        :class="{ 'last-step-standard': selectedOption == 'template', 'last-step-ai': selectedOption == 'ai' }"
      >
        <SignupAIStartupForm v-if="selectedOption == 'ai'" :contentSource="contentSource" :sourceConnected="sourceConnected" />
        <SignupTemplateStartupForm v-if="selectedOption == 'template'" :contentSource="contentSource" :sourceConnected="sourceConnected"/>
      </div>
    </div>
  </div>
</template>

<script>
import SignupAIStartupForm from "@/components/SignupAIStartupForm.vue";
import SignupTemplateStartupForm from "@/components/SignupTemplateStartupForm.vue";
export default {
  components: {
    SignupAIStartupForm,
    SignupTemplateStartupForm
  },
  data() {
    return {
      templateOptionList: [
        this.$t('signupflow.step-3.premium.options.item-1'),
        this.$t('signupflow.step-3.premium.options.item-2'),
        this.$t('signupflow.step-3.premium.options.item-3'),
        this.$t('signupflow.step-3.premium.options.item-4'),
        this.$t('signupflow.step-3.premium.options.item-5'),
        this.$t('signupflow.step-3.premium.options.item-6'),
        this.$t('signupflow.step-3.premium.options.item-7'),
      ],
      aiOptionList: [
        this.$t('signupflow.step-3.ai.options.item-1'),
        this.$t('signupflow.step-3.ai.options.item-2'),
        this.$t('signupflow.step-3.ai.options.item-3'),
        this.$t('signupflow.step-3.ai.options.item-4'),
        this.$t('signupflow.step-3.ai.options.item-5'),
      ],

      selectedOption: null,
      standardTemplateOptions: [],
      standardTemplateId: null,
      contentSource: {}
    };
  },
  props: {
    contentSourceId: {
      type: Number,
      default: null
    },
    userRequestedSolution: {
      type: String,
      default: null
    },
    sourceConnected: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    selectOption(option) {
      this.selectedOption = option;
    },
    getSource() {
      this.$store.dispatch("getContentSources").then((res) => {
        const sourceId = this.contentSourceId ? this.contentSourceId : localStorage.getItem("signupSourceID");
        this.contentSource = res.find((s) => s.id == sourceId);
      });
    }
  },
  mounted() {
    this.getSource();

    // if (this.userRequestedSolution) {
    //   switch (this.userRequestedSolution) {
    //     case "ai":
    //       this.selectedOption = "ai";
    //       break;
    //     case "premium":
    //       this.selectedOption = "template";
    //       break;
    //     default:
    //       this.selectedOption = null;
    //   }
    // }
  }
};
</script>

<style lang="less">
.step-three {
  .ai-icon {
    color: var(--ai-secondary);
  }

  .startup-options {
    margin-top: 18px;
    display: flex;
    gap: 36px;
    .option {
      position: relative;
      width: 260px;
      display: flex;
      flex-direction: column;
      height: max-content;
      padding: 18px 12px;
      border-radius: 4px;
      box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.05);
      &:hover {
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
      }

      .top {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 18px;
        margin-bottom: 18px;
        h4 {
          margin: 0;
        }
        svg,
        img {
          font-size: 12px;
          height: 14px;
        }
      }
      ul {
        padding: 0px;
        list-style: none;
        li {
          padding: 12px 0;
          font-size: 12px;
          font-weight: 500;
          line-height: 14px;
          &:first-of-type {
            padding-top: 0;
          }
          &::before {
            content: " \2022";
            transform: scale(2);
            margin-right: 12px;
          }
        }
      }

      .btn-startup {
        font-family: "Open Sans", sans-serif;
        font-size: 18px;
        width: max-content;
        align-self: end;
        border: none;
        background: none;
        display: flex;
        align-items: center;
        gap: 8px;
        transition: 0.1s;
        &:hover,
        &:focus {
          gap: 12px;
        }
      }
      &.ai-option {
        background: var(--ai-secondary-10);
        li {
          border-bottom: 1px solid #a35aff1a;
          color: var(--ai-tertiary-50);
        }

        .selected li {
          color: var(--ai-tertiary-75);
        }

        .btn-startup {
          color: var(--ai-secondary);
        }
      }
      &.template-option {
        background: var(--orange-web-10);
        li {
          border-bottom: 1px solid #f6a21c1a;
          color: var(--orange-web-80);
        }

        .selected li {
          color: var(--orange-web);
        }

        .btn-startup {
          color: var(--orange-web);
        }
      }
    }
  }

  .back-btn {
    position: absolute;
    border: none;
    background: none;
    img {
      transform: rotate(180deg);
    }
  }

  .last-step {
    padding: 18px;
    border-radius: 4px;
    border: 1px solid grey;

    max-width: 360px;
    position: relative;
    display: flex;
    flex-direction: column;
    form {
      display: flex;
      flex-direction: column;
      height: 100%;
      // justify-content: space-between;

      .selectors {
        display: flex;
        flex-direction: column;
        gap: 12px;
        margin-bottom: 12px;
      }
    }
    &.last-step-standard {
      border: 1px solid var(--orange-web);
    }
    &.last-step-ai {
      // background: var(--ai-secondary-10);
      border: 1px solid var(--ai-secondary);
    }
  }
}

#signup-flow main .last-step-standard .btn-signup-flow {
  border: 1px solid var(--orange-web);
  color: var(--orange-web);
  background: none;
  &:hover {
    background: var(--orange-web-10);
  }
}
#signup-flow main .last-step-ai .btn-signup-flow {
  border: 1px solid var(--ai-secondary);
  color: var(--ai-secondary);
  background: none;
  &:hover {
    background: var(--ai-secondary-10);
  }
}
</style>
